import i18n from 'i18next'
import detector from 'i18next-browser-languagedetector'
import { initReactI18next } from 'react-i18next'

// import en from '../../assets/locales/en'
import fr from '../../assets/locales/fr'
/**  en: {
    translation: en,
  },* */
const resources = {
  fr: {
    translation: fr,
  },
}

i18n
  .use(detector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'fr',
    interpolation: {
      escapeValue: false,
    },
  })

export default i18n
